import React from "react";
import { Helmet } from "react-helmet-async";
import PricingSection from "../components/PricingSection";

const Pricing = () => {
  return (
    <div className="flex flex-col pt-16 md:pt-20 bg-[#f5f5f5]">
      <Helmet>
        <title>Reflection Futbol Academy | Pricing</title>
        <meta
          name="description"
          content="View Reflection Futbol Academy pricing for monthly membership, individual training, and academy uniforms."
        />
        <link
          rel="canonical"
          href="https://reflectionfutbolacademy.com/pricing"
        />
        <meta
          property="og:title"
          content="Pricing | Reflection Futbol Academy"
        />
        <meta
          property="og:description"
          content="Simple pricing for academy membership, private sessions, and required gear."
        />
      </Helmet>

      <section className="relative py-12 md:py-20 bg-[#7D192A] flex items-center justify-center text-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1510279770292-4b34de9f5c23?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=60"
            alt="Football training field with players practicing"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-[#7D192A] opacity-60" />
        </div>
        <div className="relative z-10 w-full max-w-7xl mx-auto site-gutter">
          <h1 className="page-hero-title text-white uppercase">Pricing</h1>
          <div className="mt-3 md:mt-4 h-1 w-16 md:h-2 md:w-32 bg-[#F4B400] mx-auto rounded-full" />
        </div>
      </section>

      <PricingSection
        title="Investment In Development"
        eyebrow="Academy Pricing"
        intro="Choose the package that fits your training goals, with a separate section for one-time gear and uniforms."
      />
    </div>
  );
};

export default Pricing;
